import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  Paper,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  deleteCloudRep,
  getCloudRepById,
  getLeadsByCloudRepID,
  updateCloudRep,
} from "../../../api/cloudRep";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
import DeleteAlertDialog from "../../../component/DeleteAlertDialog";
import DeleteDialog from "../../../component/DeleteDialogDetailPage";
import TabPanel from "../../../component/TabPanel";
import { crmLeadsListTable as tableDefs } from "../../../config/grid-columns-defs";
import BetterControlledTable from "../../../component/BetterControlledTable";
import { CountryCodes } from "../../../countryCodes";
import { Controller } from "react-hook-form";

const emptycloudrepDetailData = {
  name: "",
  email: "",
  contact: "",
  linkedin_url: "",
  address: "",
  // designation: "",
  country_code: "",
  state: "",
  city: "",
};
export default function ViewCloudRep() {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [cloudrepDetailData, setcloudrepDetailData] = useState(
    emptycloudrepDetailData
  );
  const [cloudRepByIdTableRefreshCount, setCloudRepByIdTableRefreshCount] =
    useState(0);
  function refreshTable(e) {
    e?.preventDefault();
    setCloudRepByIdTableRefreshCount((prev) => prev + 1);
  }

  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    }
  }, [params.id]);
  async function loadMasterData() {
    try {
      const { data } = await getCloudRepById(params.id, user.token);
      console.log("datta", data.data[0]);
      setcloudrepDetailData(data.data[0]);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function oncloudrepUpdate(e) {
    e.preventDefault();
    const combineData = {
      name: cloudrepDetailData.name,
      email: cloudrepDetailData.email,
      contact: cloudrepDetailData.contact,
      linkedin_url: cloudrepDetailData.linkedin_url,
      address: cloudrepDetailData.address,
      country_code: cloudrepDetailData.country_code,
      state: cloudrepDetailData.state,
      city: cloudrepDetailData.city,
      // designation: cloudrepDetailData.designation,
    };
    try {
      const { data } = await updateCloudRep(params.id, combineData, user.token);
      loadMasterData();
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const onInputChange = (e) => {
    setcloudrepDetailData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const onDelete = () => {
    deleteCloudRep(params.id, user.token)
      .then((res) => {
        if (res.data.status == true) {
          navigate("/crmLeads");
          dispatch(showAlert(res.data.msg));
        } else {
          dispatch(showAlert(res.data.msg));
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  async function getRows(limit, offset) {
    try {
      const { data } = await getLeadsByCloudRepID(
        {
          limit,
          offset,
        },
        params.id,
        user.token
      );

      return {
        rows: data.data.CloudRepLeads,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  // Remove "Action" column from tableDef
  const tableDef = tableDefs.filter((column) => column.headerName !== "Action");
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper component="form" onSubmit={oncloudrepUpdate} sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        ></Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="name"
              label="Name"
              // required
              className="name-textfeild"
              value={cloudrepDetailData.name || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="email"
              label="Email"
              required
              value={cloudrepDetailData.email || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl
              // required
              fullWidth
            >
              <InputLabel id="demo-simple-select-label-a">
                Country Code
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-a"
                id="demo-simple-select-a"
                value={cloudrepDetailData.country_code || ""}
                label="Country Code"
                name="country_code"
                onChange={onInputChange}
              >
                {CountryCodes.map((data, key) => (
                  <MenuItem key={key} value={data.code}>
                    +{data.code} {data.country}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="state"
              fullWidth
              label="State"
              type="text"
              // required
              value={cloudrepDetailData.state || ""}
              onChange={onInputChange}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="city"
              fullWidth
              label="City"
              variant="outlined"
              type="text"
              // required
              value={cloudrepDetailData.city || ""}
              onChange={onInputChange}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="contact"
              label="Contact"
              // required
              value={cloudrepDetailData.contact || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="linkedin_url"
              label="Linkedin URL"
              value={cloudrepDetailData.linkedin_url || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="address"
              label="Address"
              value={cloudrepDetailData.address || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          {/* <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="designation"
              label="Designation"
              value={cloudrepDetailData.designation || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid> */}

          <Grid item xs={12}>
            {
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  disabled={/^Trial_User$/i.test(user.role) ? true : false}
                  variant="contained"
                  type="submit"
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
                {/* <Button
                  variant="contained"
                  onClick={() => {
                    setOpen(true);
                  }}
                  style={{ padding: "5px 7px" }}
                >
                  Delete
                </Button> */}
              </Box>
            }
          </Grid>
        </Grid>
      </Paper>
      <br />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Leads"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <div className="pmt-controll-table">
            <BetterControlledTable
              hasActionButtons={false}
              getTableRows={getRows}
              columns={tableDef}
              perPage={10}
              refreshCounter={cloudRepByIdTableRefreshCount}
            />
          </div>
        </Paper>
      </TabPanel>

      <DeleteDialog open={open} setOpen={setOpen} onDelete={onDelete} />
    </Box>
  );
}
